import {
	RESET_STATE,
	SET_LEGALS_OPTIONS,
	SET_LEGAL_INFO,
	SET_LEGAL_SEARCH_VALUE,
	SET_IS_LEGALS_OPTIONS_LOADING,
	SET_IS_LEGAL_DELETING,
	SET_IS_LEGAL_INFO_LOADING,
	SET_IS_LEGAL_UPDATING,
} from './actions';

export const initialState = {
	isLegalInfoLoading: false,
	isLegalsOptionsLoading: false,
	isLegalDeleting: false,
	isLegalUpdating: false,
	legalInfo: [],
	legalSearchValue: '',
	legalsOptions: [],
};

const legalModalReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_LEGAL_INFO:
			return {
				...state,
				legalInfo: payload,
			};
		case SET_IS_LEGAL_INFO_LOADING:
			return {
				...state,
				isLegalInfoLoading: payload,
			};
		case SET_LEGAL_SEARCH_VALUE:
			return {
				...state,
				legalSearchValue: payload,
			};
		case SET_LEGALS_OPTIONS:
			return {
				...state,
				legalsOptions: payload,
			};
		case SET_IS_LEGALS_OPTIONS_LOADING:
			return {
				...state,
				isLegalsOptionsLoading: payload,
			};
		case SET_IS_LEGAL_DELETING:
			return {
				...state,
				isLegalDeleting: payload,
			};
		case SET_IS_LEGAL_UPDATING:
			return {
				...state,
				isLegalUpdating: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default legalModalReducer;
